import { render } from "./CrashGame.vue?vue&type=template&id=1d7dd6fa&scoped=true"
import script from "./CrashGame.vue?vue&type=script&lang=js"
export * from "./CrashGame.vue?vue&type=script&lang=js"

import "./CrashGame.vue?vue&type=style&index=0&id=1d7dd6fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d7dd6fa"]])

export default __exports__